import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PageSection, IconCheckGreen } from 'adc-ui-components';
import { Link } from 'react-router-dom';

import BoxClosed from '../../components/svgs/BoxClosed';
import { kibanaLog } from '../../helpers/logger';
import { RETURNS } from '../../helpers/routes';
import AccountInfoPushdown from '../AccountInfoPushdown';


class GenericError extends Component {
  componentDidMount() {
    // todo, make this better
    kibanaLog('not_eligible');
  }

  render() {
    const { accountNumber, serviceAddress, accounts } = this.props;
    const hasLinkedAccounts = accounts && accounts.length > 1;

    return (
      <>
        <AccountInfoPushdown
          accountNumber={accountNumber}
          hasLinkedAccounts={hasLinkedAccounts}
          serviceAddress={serviceAddress}
        />
        <PageSection className="ui-grey page-section--banner">
          <IconCheckGreen className="mb12 svg-icon--42" />

          <div className="mb24">
            <h1 className="heading2 mb6">You have the latest equipment</h1>
            <p className="body2">Do you still want to update your devices? You can also change or update your plan.</p>
          </div>

          <div className="action action--right-centered">
            <div className="action__item">
              <a
                className="button button--primary"
                href="https://www.xfinity.com/buy/plan/addon/equipment"
                target="_blank"
                rel="noopener noreferrer"
              >
                Update Devices
              </a>
            </div>
            <div className="action__item">
              <a
                className="button"
                href="https://www.xfinity.com/buy/plan/offersfilter?upgrade=true"
                target="_blank"
                rel="noopener noreferrer"
              >
                Browse Offers
              </a>
            </div>
          </div>

          <div className="text-left">
            <h3>You can also view past device returns:</h3>
            <Link className="card" to={RETURNS}>
              <span className="link d-flex align-items-center">
                <BoxClosed className="mr6 svg-icon--40" />
                Device Management Center
              </span>
            </Link>
          </div>
        </PageSection>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    account: {
      data: {
        accountNumber,
        serviceAddress = {},
      } = {},
    },
    auth: {
      macaroon: {
        accounts = [],
      } = {},
    } = {},
  } = state;

  return {
    accountNumber,
    serviceAddress,
    accounts,
  };
};

export default connect(mapStateToProps)(GenericError);
